module.exports = __webpack_public_path__ + "static/media/hero_banner.d3cf44b3.png";